import { createContext, useContext } from 'react'
import { type SendingHoursStore } from 'shared/ui/Schedule/ui/SendingHours/store/sendingHoursStore'

export const SendingHoursContext = createContext<SendingHoursStore | null>(null)

export function useSendingHoursContext() {
  const context = useContext(SendingHoursContext)
  if (context === null) {
    throw new Error('You have forgotten to wrap your root component with ImmediatelyContext')
  }
  return context
}
